import { put, call } from 'redux-saga/effects'; 

import { getUnavailability,deleteUnavailability,updateUnavailability,saveUnavailability,crewUnavailability,crewUnavailabilityPerDate,unavailableCrewList} from '../services/unavailabilityService';

import * as types from '../actions';

export function* crewUnavailabilitySaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(crewUnavailability, payload);
      yield put({ type: types.CREW_UNAVAILABILITY_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.CREW_UNAVAILABILITY_ERROR, error });
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }
  
  export function* crewUnavailabilityPerDateSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(crewUnavailabilityPerDate, payload);
      yield put({ type: types.CREW_UNAVAILABILITY_PER_DATE_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.CREW_UNAVAILABILITY_PER_DATE_ERROR, error });
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }

  export function* unavailableCrewListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(unavailableCrewList, payload);
      yield put({ type: types.UNAVAILABLE_CREW_LIST_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.UNAVAILABLE_CREW_LIST_ERROR, error });
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }
  export function* saveUnavailabilitySaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(saveUnavailability, payload);
      yield put({ type: types.SAVE_UNAVAILABILITY_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.SAVE_UNAVAILABILITY_ERROR, error });
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }
  export function* updateUnavailabilitySaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(updateUnavailability, payload);
      yield put({ type: types.UPDATE_UNAVAILABILITY_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.UPDATE_UNAVAILABILITY_ERROR, error });
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }
  export function* deleteUnavailabilitySaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(deleteUnavailability, payload);
      yield put({ type: types.DELETE_UNAVAILABILITY_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.DELETE_UNAVAILABILITY_ERROR, error });
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }
  export function* getUnavailabilitySaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(getUnavailability, payload);
      yield put({ type: types.GET_UNAVAILABILITY_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.GET_UNAVAILABILITY_ERROR, error });
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }